import { render, staticRenderFns } from "./ClinicalChartReview.vue?vue&type=template&id=b551e4f2&"
import script from "./ClinicalChartReview.vue?vue&type=script&lang=js&"
export * from "./ClinicalChartReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports